import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import TinyMCE from 'react-tinymce';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import Collapsible from 'react-collapsible';
const $=window.$;
const win=window;
const jQuery=window.jQuery;


class WritingNotePad extends Component {
    constructor(props) {
        super(props);
               
        let type="LR";
       
        if(props.dlr_id>0){
            type="DLR";
        }

        
     
        this.state={
            dlr_count:0,
            title:"",
            notes_id:0,
            editorcontent:"",
            lr_mynotes:[],
            dlr_mynotes:[],
            heading_name:"",
            lr_id:props.lr_id,
            dlr_id:props.dlr_id,
            lr_type:type,
            actionType:"ADD"

        };

        this.handleEditorChange=this.handleEditorChange.bind(this);
        this.handleChange=this.handleChange.bind(this);

    }

   

    updateScrollinner5(){
        let $scrollbarin5 = jQuery('#semana-scroll-inner5');
        $scrollbarin5.tinyscrollbar();
        let scrollbarin5 = $scrollbarin5.data("plugin_tinyscrollbar");
        if(scrollbarin5){
            scrollbarin5.update("relative");
        }
    }

    updateScrollinner6(){
        let $scrollbarin6 = jQuery('#semana-scroll-inner6');
        $scrollbarin6.tinyscrollbar();
        let scrollbarin6 = $scrollbarin6.data("plugin_tinyscrollbar");
        if(scrollbarin6){
            scrollbarin6.update("relative");
        }
    }

    popup_close(){

      
        win.swal({
            //title: "Have you saved your notes?",
            text: "Have you saved your notes?",
            // text: "You will not be able to recover this imaginary file!",
            //type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#14a430',
            cancelButtonColor: '#0082c9',
            confirmButtonText: "OK",
           // cancelButtonText: "Skip",
            closeOnConfirm: true,
            animation: false,
            closeOnCancel: true
          }).then((result) => {          
            if (result) {
        
          // sa-icon sa-warning pulseWarning
              jQuery('.sa-icon').css( "display", "none" );
              jQuery('#popup2').css( "display", "none" );
              jQuery('.modal-overlay').css( "display", "none" );
              return true;
            } else {
              jQuery('.sa-icon').css( "display", "none" );
                 return false;
              }
          });
          
    }

   minimize(){

    jQuery('#popup2').css({
        height:'30px',
        width:'300px',
        overflow:'hidden',
        transform:'rotate(360deg)',
        '-webkit-transform':'rotate(360deg)',
        '-moz-transform':'rotate(360deg)',
        '-o-transform':'rotate(360deg)',
        position:'fixed', 
        transition:' all ease .4s',
        '-webkit-transition': 'all ease .4s',
        '-moz-transition': 'all ease .4s',
        '-o-transition': 'all ease .4s'

    });
	
   }

   maximize(){

    jQuery('#popup2').css({
        top:'20px',
        display: 'block',
        left:'25%',
        height:'auto',
        width:'56%',
        overflow:'unset',
        transform:'unset',
        '-webkit-transform':'unset',
        '-moz-transform':'unset',
        '-o-transform':'unset',
        position:'absolute'

    });



    // jQuery('#popup2').show();
   }

   editInfo(data,heading_name){
     
       //console.log(data);
       
//data.notes
        this.setState({
            notes_id:data.notes_id_pk,
            heading_name:heading_name,
            editorcontent:data.notes,
            title:data.notes_title,
            lr_id:this.state.lr_id,
            dlr_id:this.state.dlr_id,
            lr_type:this.state.lr_type,
            actionType:"EDIT"
        });      
        
        if(win.tinymce.get(this.refs.noteseditor.id)){

            win.tinymce.get(this.refs.noteseditor.id).setContent(data.notes);
        }
   }

   getLeftInfo(action=""){

    const {name,lr_id,dlr_id}=this.props;

    this.setState({
        heading_name:"",
        title:"",
        editorcontent:"",
        actionType:"ADD",
        lr_id:lr_id,
        dlr_id:dlr_id
    });   

    
    let learnerID   = Common.getUserData("id", true);       
    let pinID 		= Common.getUserData("pinID", true);       
    let productID 	= Common.getUserData("productID", true);  
    let pinNo 	= Common.getUserData("pinNo", true);  
    let corporateID 	= Common.getUserData("corporateID", true);      
    

    
    fetch(Config.domainUrl+'writing-pad/get-info', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' +Common.getTokenData()
        },
        body: JSON.stringify({
            learner_id: learnerID,
            pinID: pinID,
            productID:productID,
            pinNo:pinNo,
            corporateID:corporateID
        })
        }).then((response) => response.json()).then((responseJson) => {
            let data=responseJson.data;
            this.setState({

                dlr_count:data.dlr_count,
                lr_mynotes:data.lr_mynotes,
                dlr_mynotes:data.dlr_mynotes,
                heading_name:name
            });

            if(window.tinymce.get(this.refs.noteseditor.id)){

                window.tinymce.get(this.refs.noteseditor.id).setContent("");
            }

            if(action==""){

                //jQuery(".accordion_coach1").smk_Accordion().init();
                $('#parentHorizontalTab').easyResponsiveTabs({
                    type: 'default', //Types: default, vertical, accordion
                    width: 'auto', //auto or any width like 600px
                    fit: true, // 100% fit in a container
                    //closed: 'accordion', // Start closed if in accordion view
                    tabidentify: 'hor_1', // The tab groups identifier
                    activate: function (event) { // Callback function if tab is switched
        
                        var $tab = $(this);
                        var $info = $('#nested-tabInfo');
                        var $name = $('span', $info);
                        
                        $name.text($tab.text());
        
                        $info.show();
                    }
                }); 
            }                        
                    
        });
   }

   handleEditorChange(e) {
       this.setState({editorcontent:e.target.getContent()});
   
  }

  handleChange(e){
      this.setState({
          [e.target.name]:e.target.value
      })
  }


  saveNotes(){
      
      let url=Config.domainUrl+'writing-pad/save-notes';
      let learnerID   = Common.getUserData("id", true);     

      Common.reactLoader("show", "Please wait...");
      fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' +Common.getTokenData()
        },
        body: JSON.stringify({
            learner_id: learnerID,
            title: this.state.title,
            editorcontent: this.state.editorcontent,
            lr_id:this.state.lr_id,
            dlr_id:this.state.dlr_id,
            lr_type:this.state.lr_type,
            actionType:this.state.actionType,
            room_id:(this.state.lr_type=="LR")?this.state.lr_id:this.state.dlr_id,
            notes_id:this.state.notes_id
        })
        }).then((response) => response.json()).then((responseJson) => {
            Common.reactLoader("hide");
            
            if (responseJson.status == 0) {
                Common.message(responseJson.message, responseJson.errors, "error");
            }else{
                Common.message(responseJson.message,'Notes saved successfully.','success');
                this.getLeftInfo("Edit");
            }
        }); 
      
  }

  create_notes(){

    const {name,lr_id,dlr_id}=this.props;

    this.setState({
        heading_name:name,
        title:"",
        editorcontent:"",
        actionType:"ADD",
        lr_id:lr_id,
        dlr_id:dlr_id
    }); 

    if(window.tinymce.get(this.refs.noteseditor.id)){

        window.tinymce.get(this.refs.noteseditor.id).setContent("");
    }

  }
   	

    componentDidMount () {
        let self=this;       

          
       
  
		var appendthis =  ("<div class='modal-overlay js-modal-close'></div>");
		jQuery('a[data-modal-id]').click(function(e) 
		{
		    e.preventDefault();
		    jQuery("body").append(appendthis);
		    jQuery(".modal-overlay").fadeTo(500, 0.7);
		    //$(".js-modalbox").fadeIn(500);
		    var modalBox = jQuery(this).attr('data-modal-id');
            jQuery('#'+modalBox).fadeIn(jQuery(this).data());
            self.getLeftInfo();
            
		});  
  
  
		jQuery(".js-modal-close, .modal-overlay").click(function() {
		  jQuery(".modal-box, .modal-overlay").fadeOut(500, function() {
            jQuery(".modal-overlay").remove();
          
		  });
		});
 
		jQuery(window).resize(function() {
		  jQuery(".modal-box").css({
		    top: 20,//(jQuery(window).height() - jQuery(".modal-box").outerHeight()) / 2,
		    left: (jQuery(window).width() - jQuery(".modal-box").outerWidth()) / 2
		  });
		});
		 
		jQuery(window).resize();
 
    
            let $scrollbarin5 = jQuery('#semana-scroll-inner5');
            $scrollbarin5.tinyscrollbar();

            let $scrollbarin6 = jQuery('#semana-scroll-inner6');
            $scrollbarin6.tinyscrollbar();

      
    }
    
    componentWillReceiveProps(nextProps){

        let type="LR";
       
        if(nextProps.dlr_id>0){
            type="DLR";
        }

        
        this.setState({
            lr_id:nextProps.lr_id,
            dlr_id:nextProps.dlr_id,
            lr_type:type
        })
    }
    
    goTonotes(type){
        const {name,lr_id,dlr_id}=this.props;

        this.props.notesList(type,lr_id,dlr_id);
        
    }
    
    render () {
        const {name,lr_id,dlr_id}=this.props;

      
        
        return (
            <div id="popup2" style={{top: '20px',left: '297px',display: 'none'}} className="modal-box popup-ecoach">
                <div className="buttons-bar">
                    <a href="javascript:void(0);" onClick={(e)=>this.popup_close()} title="Close"><img src={process.env.PUBLIC_URL+'/images/cloze.png'}/></a>
                    <a href="javascript:void(0);" onClick={(e)=>this.minimize()} title="Minimize" className="" style={{marginRight: "35px"}}><img src="images/min.png"/></a>
                    <a href="javascript:void(0);" onClick={(e)=>this.maximize()} title="Maximize"><img src={process.env.PUBLIC_URL+'/images/max.png'}/></a>
                </div>
                <h2 className="write-pad-tiltle"><img src={process.env.PUBLIC_URL+'/images/wiriting-pad-icon.png'} border="0"/> Writing Pad</h2>
                <div className="modal-body popup-grey">
                <div className="writing-pad-outer">
                <div className="writing-pad-top">
                <div className="pad-left">
                    <div id="parentHorizontalTab">
                        <ul className="resp-tabs-list hor_1">
                            <li>LR</li>
                            {this.state.dlr_count>0 &&
                                 <li>DLR</li>
                            }
                        </ul>

              <div className="resp-tabs-container hor_1">                
                <div className="tab-content">

                  <div className="accordion_coach1">
                  
                    <section id="semana-scroll-inner5" className="scrollbar1">

                    <section className="scrollbar">
                        <section className="track">
                            <section className="thumb"></section>
                        </section>
                    </section>

                    <section className="viewport">
                     {this.state.lr_mynotes!=undefined &&
                        <section className="overview">
                      
                        {this.state.lr_mynotes.map((key,i)=>
                        <Collapsible key={`notes_lr_main_${i}`}  trigger={`LR-${key.lr_name}`}>
                       
                       {key.notes!=null &&                            
                        <div className="acc_content">
                            <ul>
                                    
                                {key.notes.map((value,inc)=>
                                    
                                    <li key={`notes_lr_title_${inc}`}>
                                    <a href="javascript:void(0);" onClick={(e)=>this.editInfo(value,`LR-${key.lr_name}`)} >{value.notes_title}</a>
                                    </li>
                                )}
                            </ul>
                        </div>
                       }
                     </Collapsible> 
                    )}       
                   
                     </section>
                     }
                     </section>
                   </section>
                </div>
                </div>              

                
                <div className="tab-content">
                  <div className="accordion_coach1">
                  
                    <section id="semana-scroll-inner6" className="scrollbar1">

                    <section className="scrollbar">
                        <section className="track">
                            <section className="thumb"></section>
                        </section>
                    </section>

                    <section className="viewport">
                    {this.state.dlr_mynotes!=undefined &&
                        <section className="overview">

                        {this.state.dlr_mynotes.map((key,i)=>
                         <Collapsible key={`notes_dlr_main_${i}`}  trigger={`DLR-${key.lr_name}`}>
                      
                       {key.notes!=null &&                            
                        <div className="acc_content">
                            <ul>
                                    
                                {key.notes.map((value,inc)=>
                                    
                                        <li key={`notes_dlr_title_${inc}`}><a href="javascript:void(0);" onClick={(e)=>this.editInfo(value,`DLR-${key.lr_name}`)} >{value.notes_title}</a></li>
                                )}
                            </ul>
                        </div>
                       }
                     </Collapsible> 
                    )}       
                   
                     </section>
                    }
                     </section>
                   </section>
                </div>
                </div>

                </div>
                </div>


                </div>               


             <div className="pad-right">
            <div className="pad-right-form">
            	<h2 className="cat_head_rgt">
            		<div id="learning_room_title" >
                    {(this.state.heading_name!="")?this.state.heading_name:name} 
                    </div>
            	</h2>
            	<ul className="padtag">
            		<li>
		            	<input type="text" name="title" id="notes_title" onChange={this.handleChange} value={this.state.title} placeholder="" />
		            	<div id="div_notes_title" className="error" ></div>
		            </li>
		            <li>
                    <div style={{float:'left', width:'100%'}}>  
                   
                        <TinyMCE
                            ref="noteseditor"
                            content={this.state.editorcontent}
                            config={{
                            menubar: false,    
                            plugins: 'autolink link image lists print preview',
                            toolbar: 'bold italic | alignleft aligncenter alignright',
                            branding: false
                            }}
                            onChange={this.handleEditorChange}
                        />
		            
		            	<div id="div_writing_txtarea" className="error" ></div>
                      </div>  
		            </li>
		            <li>
                    <input type="button" style={{padding: "0px 10px",fontSize: "15px",backgroundColor:"#d24d57",border: "medium none",width:"auto"}} onClick={(e)=>this.saveNotes()} value="SAVE NOTES"/>
			            	
                            </li>
                          </ul>
                    </div>
                </div>

            </div>           
            </div>
            </div>
                <div className="writing-pad-bottom">
                    <input type="button" onClick={(e)=>this.create_notes()}  value="Create New Notes" />
                    <input type="button" onClick={(e)=>this.goTonotes('seek_notes')} value="Seek Notes" />
                    <input type="button" onClick={(e)=>this.goTonotes('sharek_notes')} value="Share Notes" />
                    <input type="button" onClick={(e)=>this.goTonotes('share_requests')} value="Share Requests" />
                    <input type="button" onClick={(e)=>this.goTonotes('all_notes')} value="All Notes" />
                </div>
            </div>
              
        )
    }
}

export default WritingNotePad


// WEBPACK FOOTER //
// ./src/lr_dlr_components/partials/WritingNotePad.js